import { AspectFilterRegistryItem } from '../AspectFilterRegistryItem';
import { AspectFilterRegistryCategory } from '../AspectFilterRegistryCategory';
export class AspectFilterByName extends AspectFilterRegistryCategory {
    label = 'by Name';
    constructor(parent) {
        super(parent);
        ['core', 'essence', 'inner', 'outer', 'position'].forEach(name => {
            this[name] = () => new AspectFilterRegistryItem({ label: name, filter: ({ a }) => a.name === name });
        });
        super.init();
    }
}
